import { useStoreWithEqualityFn } from 'zustand/traditional'
import { SetPasswordStore } from '@/scopes/auth/domain/types'
import { useSetPasswordDependencies } from './setPasswordDependencies'

export function useSetPasswordStore<T>(
  selector: (state: SetPasswordStore) => T,
  equalityFn?: (a: T, b: T) => boolean,
): T {
  const { store } = useSetPasswordDependencies()
  if (!store) {
    throw new Error('store not provided')
  }

  return useStoreWithEqualityFn(store, selector, equalityFn)
}
